import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import { Loader } from "./Loader";

export const LoaderPortal = () => {
  const isLoading = useSelector((state) => state.isLoading);

  return createPortal(
    isLoading ? <Loader /> : null,
    document.getElementById("loader")
  );
};
